import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { RecurringInvoiceEmailTemplateContextProvider } from './contexts/recurringInvoiceEmailTemplateContext'
import { RecurringInvoiceEmailTemplateModalBody } from './elements/RecurringInvoiceEmailTemplateModalBody'
import { RecurringInvoiceEmailTemplateModalFooter } from './elements/RecurringInvoiceEmailTemplateModalFooter'

type RecurringInvoiceEmailTemplateModalProps = ModalProps

export const RecurringInvoiceEmailTemplateModalComponent = (modalProps: RecurringInvoiceEmailTemplateModalProps) => {
  const { t } = useTranslation()

  return (
    <RecurringInvoiceEmailTemplateContextProvider>
      <Modal {...modalProps} size="s" closable>
        <Modal.Header
          title={t('external_invoices.editor.form.recurring_invoice_settings.email_template.modal.title')}
        />
        <RecurringInvoiceEmailTemplateModalBody />
        <RecurringInvoiceEmailTemplateModalFooter />
      </Modal>
    </RecurringInvoiceEmailTemplateContextProvider>
  )
}

export const RecurringInvoiceEmailTemplateModal = withModalConditionalRender(
  RecurringInvoiceEmailTemplateModalComponent,
)
